import React from 'react';
import { Spinner } from 'spa/components/Indicators';

const withLoadingSpinner = (WrappedComponent) =>
  function WithLoadingComponent({ isLoading, ...props }) {
    if (isLoading) return <Spinner />;
    return <WrappedComponent {...props} />;
  };
export default withLoadingSpinner;
